export default __webpack_public_path__ + "static/media/infoTooltip.cf7c3036.svg";